import React, { Component } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import { ValidationHelper } from '../helpers/ValidationHelper';

import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';
import { AppTheme } from '../styles/AppTheme';
import {
  StyleSheet,
  css
} from 'aphrodite';

export class CheckboxComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    }
  }

  change = e => {
    this.setState({ value: e.target.value });
    this.props.setValue(e.target.value, this.props.formField.key)
  }

  render() {
    console.log()
    return (
      <FormControl className={css(Styles.inputCss)}>
        <InputLabel
          className={css(Styles.inputLabel)}
          classes= {{
            shrink : css(Styles.inputLabelShrink)
          }}>
          {this.props.formField.label}
        </InputLabel>
        <Select
          multiple
          value={this.state.value}
          onChange={e => this.change(e)}
          renderValue={selected => selected.join(', ')}
          renderValue={selected => (
            this.props.formField.options.map(item => {
              return (
                selected.map(key => {
                  return (
                    key === item.key &&
                    [item.name] + ', '
                  )
                }))
            })
          )}
          disabled={this.props.disabled}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left'
            },
            getContentAnchorEl: null,
            classes: {
              paper: css(CommonStyles.menuItemContainerRoot),
              list: css(CommonStyles.menuItemListContainerRoot)
            }
          }}
          input={
            <Input
              disableUnderline={true}
            />
          }
          classes={{
            selectMenu: this.props.action === 'viewInfo' ? css(Styles.selectMenu,Styles.textFieldContentInputView) : css(Styles.selectMenu),
            icon: this.props.action === 'viewInfo' ? css(Styles.selectIconView) : css(Styles.selectIcon),
          }}
        >
          {this.props.formField.options.map(item => {
            return (
              <MenuItem
                key={item.key}
                value={item.key}
                className={css(CommonStyles.menuItemContainer)}>
                <Checkbox
                  checked={this.state.value.indexOf(item.key) > -1}
                  className={css(Styles.selectCheckbox)} />
                <ListItemText primary={item.name} />
              </MenuItem>
            )
          })}
        </Select>

        <FormHelperText
          className={css(Styles.errorMsgStyle)}>
          {!this.props.enableValidation ? '' : ValidationHelper.validateFields(this.props.formField, this.state.value)}
        </FormHelperText>

      </FormControl>
    )
  }
}

const Styles = StyleSheet.create({
  inputCss: {
    margin: 8,
    flex: 1,
    color: AppTheme.white,
    minHeight: AppTheme.formFieldHeight
  },
  inputLabel: {
    color: AppTheme.white,
    marginLeft: 8,
    opacity: .6,
    zIndex: 1,
    pointerEvents: 'none',
    '@media(max-width: 767px)': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      right: 22,
    }
  },
  inputLabelShrink: {
    right: 'unset'
  },
  selectMenu: {
    backgroundColor: AppTheme.secondaryColor,
    color: AppTheme.white,
    paddingLeft: 8
  },
  textFieldContentInputView: {
    backgroundColor: AppTheme.primaryBackground,
  },
  selectIcon: {
    color: AppTheme.white
  },
  selectIconView: {
    color: AppTheme.primaryBackground
  },
  selectCheckbox: {
    color: AppTheme.white
  },
  errorMsgStyle: {
    color: AppTheme.white,
    paddingLeft: 8
  },
})


// WEBPACK FOOTER //
// ./src/components/CheckboxComponent.js